/**
 * Read-more disclosure for long prose.
 *
 * CSS clamps the body on phones (gated on `tt-clamp:defined`, so no JS means
 * no clamp and nothing is ever unreachable). This element's whole job is the
 * toggle: show it only when the clamp is actually hiding lines — a "Read
 * more" under text that is fully visible reads as a broken link.
 */
class Clamp extends HTMLElement {
  #cleanup;
  connectedCallback() {
    const body = this.querySelector('[data-clamp-body]');
    const toggle = this.querySelector('[data-clamp-toggle]');
    if (!body || !toggle) return;

    const sync = () => {
      const open = this.classList.contains('is-open');
      toggle.hidden = !open && body.scrollHeight <= body.clientHeight + 2;
      toggle.setAttribute('aria-expanded', String(open));
    };

    const onClick = () => {
      const open = this.classList.toggle('is-open');
      toggle.textContent = open ? toggle.dataset.less : toggle.dataset.more;
      sync();
    };
    toggle.addEventListener('click', onClick);

    window.addEventListener('resize', sync);
    this.#cleanup = () => {
      toggle.removeEventListener('click', onClick);
      window.removeEventListener('resize', sync);
    };
    sync();
  }

  disconnectedCallback() { this.#cleanup?.(); }
}

if (!customElements.get('tt-clamp')) {
  customElements.define('tt-clamp', Clamp);
}
